module.exports = __webpack_public_path__ + "static/img/noNews.46d616c1.png";